import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import { useApi } from '@tabeeb/modules/shared/utils/API/hooks'

import { QualificationsQueryKeys } from '../queries'

const useQualificationSearch = (search: string = '') => {
  const { certificateServiceApi } = useApi()

  const query = useQuery({
    queryKey: [QualificationsQueryKeys.QualificationsSearch, search],
    queryFn: () => certificateServiceApi.qualifications.getSearchedAsync({ search }),
    staleTime: 30000,
  })

  return useMemo(() => ({ loading: query.isLoading, qualifications: query.data }), [query.data, query.isLoading])
}

export default useQualificationSearch
